<div class="row">
  <div class="col-md-12 ">
    <app-warehouse-list></app-warehouse-list>
  </div>
</div>
